export default "/images/vendor/flag-icons/flags/1x1/uz.svg?15a9a22cda20d4284071e41629890cf5";